import { useStaticQuery, graphql } from "gatsby";

const aboutUsQuery = graphql`
  query {
    allAboutUsJson {
      nodes {
        title
        image
        content {
          body
        }
      }
    }
  }
`;

export const useAboutUs = () => {
  const data = useStaticQuery(aboutUsQuery);
  console.log(data);
  return data.allAboutUsJson.nodes[0] || {};
};
